/* src/app/shared/order-form/order-form/order-form-items/order-form-items.component.scss */
:host {
  max-width: 100%;
}
.header {
  margin-top: 40px;
}
.cw-samples-inventory-items-header {
  border-bottom: 1px solid var(--color-accent);
  font-weight: 700;
  margin: 20px 0 10px;
  padding-bottom: 10px;
  width: fit-content;
}
form .cw-flex-row {
  align-items: center;
  padding: 8px 0;
}
form .cw-flex-row ::ng-deep .cw-input {
  margin-bottom: 0;
}
.cw-erp-number {
  min-width: 70px;
  max-width: 70px;
  margin: 0 25px 0 5px;
}
.cw-pzn-number {
  min-width: 70px;
  max-width: 70px;
  margin: 0 25px 0 5px;
}
.cw-product-label {
  min-width: 150px;
  max-width: 150px;
  margin: 0 25px 0 5px;
}
.duplicate-icon-header {
  min-width: 28px;
  max-width: 28px;
  margin: 0 4px;
}
form .cw-flex-row .cw-toolbar-icon {
  background-color: transparent;
  border: 1px solid transparent;
  color: var(--color-primary-dark);
  font-size: 12px;
  height: 25px;
  margin-left: 2px;
  width: 25px;
}
form .cw-flex-row .cw-toolbar-icon:hover {
  border-color: var(--color-primary-dark);
}
form .cw-flex-row .cw-toolbar-icon:active {
  background-color: var(--color-primary-dark);
  color: var(--color-default-light);
}
form .cw-flex-row .cw-amount {
  min-width: 120px;
  max-width: 120px;
  width: 10%;
  margin: 0 15px 0 15px;
}
.cw-amount-wrapper {
  display: flex;
  flex-direction: column;
}
.cw-order-amount-error-msg {
  max-width: 120px;
  white-space: normal;
  color: var(--color-accent);
  font-size: 0.75em;
  margin: 2px 15px 0 15px;
}
.cw-amount::-webkit-inner-spin-button,
.cw-amount::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}
form .cw-flex-row .cw-price {
  min-width: 80px;
  max-width: 80px;
  width: 10%;
  padding: 0 5px 0 5px;
  text-align: right;
}
form .cw-flex-row .cw-discount {
  min-width: 80px;
  max-width: 80px;
  width: 10%;
  padding: 0 25px 0 5px;
  text-align: right;
}
form .cw-flex-row .cw-batch {
  min-width: 140px;
  max-width: 140px;
  width: 10%;
  padding: 0 5px 0 5px;
}
form .cw-flex-row .cw-row-action {
  min-width: 32px;
  max-width: 32px;
  display: flex;
  justify-content: center;
}
form .cw-flex-row .cw-ordered-amount {
  min-width: 80px;
  max-width: 80px;
  width: 10%;
  padding: 0 25px 0 5px;
}
form .cw-flex-row .cw-contingent {
  min-width: 80px;
  max-width: 80px;
  width: 10%;
  padding: 0 5px 0 5px;
}
form .cw-flex-row .cw-remaining-amount {
  min-width: 120px;
  max-width: 120px;
  width: 10%;
  padding: 0 5px 0 5px;
}
form .cw-flex-row .cw-note {
  min-width: 100px;
  max-width: 100px;
  width: 28%;
}
.cw-error-messages {
  padding-right: 20px;
}
::ng-deep .mat-select-arrow-wrapper {
  visibility: hidden;
}
:host .cw-amount-exceed ::ng-deep .cw-input-input,
.cw-amount-exceed {
  color: var(--color-tour-critical-bright);
  border-color: var(--color-tour-critical-bright);
}
.cw-amount-invalid {
  color: var(--color-disabled, #aaa);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.cw-employee-supply-order-item-card {
  overflow-x: auto;
}
.cw-search-icon {
  cursor: pointer;
  margin: 6px;
}
:host .cw-erp-number ::ng-deep .cw-input-span {
  overflow: hidden;
  text-overflow: ellipsis;
}
.overflow-container {
  overflow: auto;
}
.select {
  min-width: 150px;
  max-width: 150px;
  margin: 0 25px 0 5px;
}
.select-secondary-discount {
  min-width: 175px;
  max-width: 175px;
  margin: 0 25px 0 5px;
}
.select-secondary-discount ::ng-deep span.icon-delete {
  margin-left: 6px;
}
.no-padding {
  padding: 0 !important;
}
.duplicate-icon-padding {
  padding: 0 4px;
}
:host ::ng-deep .duplicate-icon svg {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
:host ::ng-deep .duplicate-icon {
  justify-content: center;
  align-items: center;
}
:host ::ng-deep .duplicate-icon:hover {
  color: var(--color-accent);
}
.duplicated-row {
  background-color: rgba(128, 128, 128, 0.08);
  box-shadow: inset 3px 0 0 var(--color-accent);
  transition: background-color 0.2s ease;
  width: 100%;
  min-width: max-content;
  opacity: 0;
  animation: fadeIn 0.3s ease forwards;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/*# sourceMappingURL=order-form-items.component.css.map */
